import { Controller } from "@hotwired/stimulus"

// Generic +/- number stepper. Wraps a real number input (kept for its name,
// min/max and any other data-actions) and drives it from two buttons.
// On every change it dispatches a native `input` event so listeners such as
// reservation-pricing pick up the new value.
export default class extends Controller {
  static targets = ["input", "decrement", "increment"]

  connect() {
    this.#refresh()
  }

  increment() {
    this.#setValue(this.#value + 1)
  }

  decrement() {
    this.#setValue(this.#value - 1)
  }

  #setValue(next) {
    this.inputTarget.value = String(this.#clamp(next))
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.#refresh()
  }

  #refresh() {
    if (this.hasDecrementTarget) this.decrementTarget.disabled = this.#value <= this.#min
    if (this.hasIncrementTarget) this.incrementTarget.disabled = this.#value >= this.#max
  }

  #clamp(value) {
    return Math.min(this.#max, Math.max(this.#min, value))
  }

  get #value() {
    return parseInt(this.inputTarget.value, 10) || 0
  }

  get #min() {
    return this.inputTarget.min === "" ? -Infinity : parseInt(this.inputTarget.min, 10)
  }

  get #max() {
    return this.inputTarget.max === "" ? Infinity : parseInt(this.inputTarget.max, 10)
  }
}
